// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lz-0";